<div class="notification-container">
  <div nxModalContent class="std-ta-center nx-margin-bottom-2m">
    <h1 nxHeadline="subsection-medium" class="nx-margin-bottom-s">
      {{ data.message }}
    </h1>
  </div>

  <div nxModalActions class="action-btn" *ngIf="data.button === 'OK'">
    <button
      type="button"
      nxButton="secondary"
      class="std-mg-bottom-auto"
      (click)="closeDialog()"
    >
      {{ "GLOBAL.ACTION.OK" | translate }}
    </button>
  </div>

  <div nxModalActions class="action-btn" *ngIf="data.button === 'COSTOME'">
    <button
      type="button"
      nxButton="secondary"
      class="std-mg-bottom-auto"
      (click)="closeDialog()"
    >
      {{ data.buttonMessage }}
    </button>
  </div>

  <div nxModalActions class="action-btn" *ngIf="data.button === 'OPTIONAL'">
    <button
      type="button"
      nxButton="secondary"
      class="std-mg-bottom-auto"
      (click)="continue()"
    >
      {{ "GLOBAL.ACTION.CONTINUE" | translate }}
    </button>
    <button
      type="button"
      nxButton="secondary"
      class="std-mg-bottom-auto"
      (click)="closeDialog()"
    >
      {{ "GLOBAL.ACTION.CANCEL" | translate }}
    </button>
  </div>
</div>
